import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { sortArray } from '@nu-art/ts-common';
import { _className } from '../../../../utils/tools.js';
import './ItemEditor_DefaultList.scss';
import { ComponentSync } from '../../../../core/ComponentSync.js';
import { ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '../../../../component-modules/mouse-interactivity/index.js';
import { Button } from '../../../Button/Button.js';
import { VirtualizedList } from '../../../TS_VirtualizedList/index.js';
export class ItemEditor_DefaultList extends ComponentSync {
    listContainerRef;
    deriveStateFromProps(nextProps, state) {
        if (nextProps === this.props || nextProps.module !== this.props.module) {
            // @ts-ignore
            delete this[this.props.module.defaultDispatcher.method];
            // @ts-ignore
            this[nextProps.module.defaultDispatcher.method] = (...args) => this.__onItemUpdated(...args);
        }
        state = super.deriveStateFromProps(nextProps, state);
        return state;
    }
    shouldComponentUpdate() {
        return true;
    }
    __onItemUpdated = (...params) => {
        return this.forceUpdate();
    };
    openItemMenu = (e, item) => {
        const menuActions = this.props.contextMenuItems;
        if (!menuActions?.length)
            return;
        const model = {
            id: 'permission-editor-item-menu',
            originPos: { x: e.clientX, y: e.clientY },
            modalPos: { x: 1, y: 1 },
            content: () => _jsx(_Fragment, { children: menuActions.map((action, index) => {
                    return _jsx(Button, { onClick: async () => {
                            const shouldClose = await action.action(item) ?? false;
                            if (shouldClose)
                                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        }, children: action.label }, index);
                }) })
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    render() {
        const filteredItems = this.props.module.cache.filter(this.props.filter ?? (() => true));
        const sort = this.props.sort || ((items) => sortArray(items, i => i.__createdAt));
        const items = sort(filteredItems);
        const itemsToRender = items.map(item => {
            return _jsx("div", { onContextMenu: (e) => this.openItemMenu(e, item), className: _className('match_parent', 'list-item', item._id === this.props.selected?._id && 'list-item__selected'), onClick: (e) => {
                    if (e.metaKey) {
                        if (e.shiftKey)
                            this.logInfo(`item: ${item._id}`, item);
                        else
                            this.logInfo(`item: ${item._id}`);
                        return;
                    }
                    this.props.onSelected(item);
                }, children: this.props.itemRenderer(item) }, item._id);
        });
        return _jsx("div", { className: 'items-list match_height', ref: (instance) => {
                if (this.listContainerRef)
                    return;
                this.listContainerRef = instance;
                this.forceUpdate();
            }, children: _jsx(VirtualizedList, { className: 'match_parent', listToRender: itemsToRender, itemHeight: 50, height: this.listContainerRef?.clientHeight ?? 0 }) });
    }
}
//# sourceMappingURL=ItemEditor_DefaultList.js.map